import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import customerApi from 'src/api/customer'
import courseApi from 'src/api/course'

// fetch customer orders by customerId
// First, create the customer thunk
export const fetchCustomerOrderById = createAsyncThunk(
  'customers/fetchCustomerOrderByIdStatus',
  async (customerId) => {
    const detail = await customerApi.getCustomerAllDetailsById(customerId)
    return detail
  }
)

// Then, handle actions in reducers:
const initialState = {
  isModalOpen: false,
  modalViewName: null,
  modalViewParams: null,
  serviceProgressList: null,
  serviceArray: null,
  serviceProgress: null,
  serviceFinshed: null,
  packageArray: null,
  servicePackageProgress: null,
  detail: null,
  contect: null,
  loading: true,
  error: '',
  status: '',
  CourseIds: null,
  selectedIndex: null,
}

const slice = createSlice({
  name: 'customers',
  initialState,
  reducers: {
    setSearchCustomer(oldState, action) {
      oldState.detail = action.payload
    },
    setCustomerDetail(oldState, action) {
      oldState.detail = action.payload
    },

    setSelectedIndex(oldState, action) {
      oldState.selectedIndex = action.payload
    },

    setCustomerServiceArray(OldState, action) {
      const serviceProgressList = action.payload
      const serviceArray = []
      const packageArray = []
      if (!serviceProgressList || !serviceProgressList.content) {
        OldState.serviceArray = []
        OldState.serviceFinshed = []
        OldState.serviceProgress = []
        OldState.packageArray = []
        OldState.servicePackageProgress = []
        return
      }
      try {
      serviceProgressList.content.map((service, idx) => {
        let packageInnerArray = []
        if (!service.courseProducts) return
        service.courseProducts.map((item, index) => {
          if (item.product) {
              serviceArray.push({
                ...item,
                serviceDate: service.recordDateTime.slice(0, 10),
                serviceDateTime: service.recordDateTime,
                serviceTime: service.recordDateTime.slice(11, 19),
              })
          } else if (item.packages) {
            packageInnerArray.push(item)
          }
        })
        if (packageInnerArray.length !== 0) {
          packageArray.push(packageInnerArray)
        }
      })


      const serviceProgress = []
      const serviceFinshed = []
      const packageProgress = []

      // create array for puchased incomplete service in progress
      for (var i = 0; i < serviceArray.length; i++) {
        serviceProgress.push(Array())
        serviceFinshed.push(serviceArray[i].courseRecords)
        serviceProgress[i].push({
          ...serviceArray[i],
          signatureCode: 0,
          comment: '',
          productId: serviceArray[i].product ? serviceArray[i].product.id : null,
        })
      }

      // create array for puchased incomplete package in progress
      packageArray.map((packages, idx) => {
        packageProgress.push(Array())
        for (var i = 0; i < packages.length; i++) {

          if (packages[i].courseRecords) {
            packages[i].courseRecords.map((record) =>
              packageProgress[idx].push(record)
            )
          }
        }
      })

      OldState.serviceArray = serviceArray
      OldState.serviceFinshed = serviceFinshed
      OldState.serviceProgress = serviceProgress
      OldState.packageArray = packageArray
      OldState.servicePackageProgress = packageProgress
      } catch (e) {
        console.error('setCustomerServiceArray error:', e)
        OldState.serviceArray = []
        OldState.serviceFinshed = []
        OldState.serviceProgress = []
        OldState.packageArray = []
        OldState.servicePackageProgress = []
      }
    },
    updateCustomerServiceArray(oldState, action) {
      const serviceProgressList = action.payload
      let serviceFinshed = [...oldState.serviceFinshed]
      let serviceArray = [...oldState.serviceArray]
      let servicePackageProgress = [...oldState.servicePackageProgress]
      let idx = oldState.selectedIndex

      if (serviceProgressList.courseProducts[0].product) {
        serviceFinshed = [
          ...serviceFinshed.slice(0, idx),
          serviceProgressList.courseProducts[0].courseRecords,
          ...serviceFinshed.slice(idx + 1, serviceFinshed.length),
        ]

        serviceArray = [
          ...serviceArray.slice(0, idx),
          serviceProgressList.courseProducts[0],
          ...serviceArray.slice(idx + 1, serviceArray.length),
        ]
      }
      if (serviceProgressList.courseProducts[0].packages) {
        servicePackageProgress = [
          ...servicePackageProgress.slice(0, idx),
          serviceProgressList.courseProducts[0].courseRecords,
          ...servicePackageProgress.slice(
            idx + 1,
            servicePackageProgress.length
          ),
        ]
      }
      oldState.serviceFinshed = serviceFinshed
      oldState.serviceArray = serviceArray
      oldState.servicePackageProgress = servicePackageProgress
    },
    updateTimesCustomerServiceArray(oldState, action) {     
      let idx = oldState.selectedIndex   
      oldState.serviceArray[idx] = action.payload
    },
    /* service Progress */
    setCustomerServiceProgressList(oldState, action) {
      oldState.serviceProgressList = action.payload
    },

    setCustomerContect(oldState, action) {
      oldState.contect = action.payload
    },

    resetCustomerContact(oldState) {
      oldState.detail = null
      oldState.contect = null
      oldState.loading = true
      oldState.error = ''
      oldState.status = ''
    },

    openModal(oldState) {
      oldState.isModalOpen = true
    },

    closeModal(oldState) {
      oldState.isModalOpen = false
      oldState.modalViewName = null
      oldState.modalViewParams = null
    },

    setModalViewName(oldState, action) {
      oldState.modalViewName = action.payload
    },

    setModalViewParams(oldState, action) {
      oldState.modalViewParams = action.payload
    },
  },

  // handle actions loading state
  extraReducers: {
    [fetchCustomerOrderById.pending]: (oldState, action) => {
      oldState.status = 'loading'
      oldState.loading = true
    },
    [fetchCustomerOrderById.fulfilled]: (oldState, action) => {
      oldState.status = 'succeeded'
      // fetched customer orders to the state
      oldState.detail = action.payload
      oldState.loading = false
    },
    [fetchCustomerOrderById.rejected]: (oldState, action) => {
      oldState.status = 'failed'
      oldState.error = action.error.message
    },
  },
})

export const reducer = slice.reducer

// fetch customer contact info by customer id (backend generate)
export const getCustomerContactById = (customerId) => async (dispatch) => {
  const contect = await customerApi.getCustomerById(customerId)
  dispatch(slice.actions.setCustomerContect(contect))
}

// fetch customer contact info by refId (employee generate)
export const getCustomerContactByRefId = (refId) => async (dispatch) => {
  const contect = await customerApi.getCustomerByRefId(refId)
  dispatch(slice.actions.setCustomerContect(contect))
}

// add edit customer info
export const addEditCustomerInfo = (requestBody) => async (dispatch) => {
  const contect = await customerApi.addEditCustomerInfo(requestBody)
  dispatch(slice.actions.setCustomerContect(contect))
  return contect
}

export const resetCustomerContectSlice = () => (dispatch) => {
  dispatch(slice.actions.resetCustomerContact())
}

// update customer info
// export const editCustomerInfo = (customerId, requestBody) => async (
//   dispatch
// ) => {
//   const contect = await customerApi.editCustomerInfo(customerId, requestBody)
//   const originalReduxData = await customerApi.getCustomerAllDetailsById(
//     customerId
//   )
//   dispatch(slice.actions.setCustomerDetail(contect))
// }

/**
 * orderdetail  add || delete || edit  serviceProgress
 */

export const addCourseRecord = (
  customerId,
  courseId,
  courseRecordDto
) => async (dispatch) => {
  await courseApi.addCourseRecord(courseId, courseRecordDto)
  const originalReduxData = await customerApi.getCustomerAllDetailsById(
    customerId
  )
  dispatch(slice.actions.setCustomerDetail(originalReduxData))
}

export const editCourseRecord = (
  customerId,
  courseId,
  index,
  courseRecordDto
) => async (dispatch) => {
  await courseApi.editCourseRecord(courseId, index, courseRecordDto)
  const originalReduxData = await customerApi.getCustomerAllDetailsById(
    customerId
  )
  dispatch(slice.actions.setCustomerDetail(originalReduxData))
}

export const deleteCourseRecord = (customerId, courseId, index) => async (
  dispatch
) => {
  await courseApi.deleteCourseRecord(courseId, index)
  const originalReduxData = await customerApi.getCustomerAllDetailsById(
    customerId
  )
  dispatch(slice.actions.setCustomerDetail(originalReduxData))
}

/**
 * 订单详情里面添加 || 删除 || 修改 payment
 */

export const addCustomerPayment = (customerId, courseId, paymentDto) => async (
  dispatch
) => {
  await courseApi.addCoursePayment(courseId, paymentDto)
  const originalReduxData = await customerApi.getCustomerAllDetailsById(
    customerId
  )
  dispatch(slice.actions.setCustomerDetail(originalReduxData))
}

export const editCustomerPayment = (
  customerId,
  courseId,
  id,
  paymentDto
) => async (dispatch) => {
  await courseApi.editCoursePayment(courseId, id, paymentDto)
  const originalReduxData = await customerApi.getCustomerAllDetailsById(
    customerId
  )
  dispatch(slice.actions.setCustomerDetail(originalReduxData))
}

export const deleteCustomerPayment = (customerId, courseId, id) => async (
  dispatch
) => {
  await courseApi.deleteCoursePayment(courseId, id)
  const originalReduxData = await customerApi.getCustomerAllDetailsById(
    customerId
  )
  dispatch(slice.actions.setCustomerDetail(originalReduxData))
}

/**
 * Modal
 */
export const setModalViewName = (viewName) => (dispatch) => {
  dispatch(slice.actions.setModalViewName(viewName))
}

export const setModalViewParams = (params) => (dispatch) => {
  dispatch(slice.actions.setModalViewParams(params))
}

export const openModal = () => (dispatch) => {
  dispatch(slice.actions.openModal())
}

export const closeModal = () => (dispatch) => {
  dispatch(slice.actions.closeModal())
}

/* Service Progress */

export const getCustomerServiceProgress = (customerId) => async (dispatch) => {
  try {
    const serviceProgressList = await courseApi.getServiceListById(customerId)
    dispatch(slice.actions.setCustomerServiceProgressList(serviceProgressList))
    dispatch(slice.actions.setCustomerServiceArray(serviceProgressList))
  } catch (err) {
    console.error('getCustomerServiceProgress failed:', err)
    dispatch(slice.actions.setCustomerServiceArray(null))
  }
}

export const deleteCourseRecords = (
  courseId, 
  index, 
  customerId, 
  selectedIndex,
  ispackage,
  ) => async (dispatch) => {
  const detail = await courseApi.deleteCourseRecord(courseId, index)
  if(!ispackage){
  dispatch(slice.actions.setSelectedIndex(selectedIndex))
  dispatch(slice.actions.updateCustomerServiceArray(detail))
  }
}

export const sendSignatureMessage = (

  courseId,
  courseRecordDto,
  employeeId,
  phoneNumber,
  selectedIndex,
  ispackage,
) => async (dispatch) => {
  dispatch(slice.actions.setSelectedIndex(selectedIndex))
  const updateRecord = await customerApi.sendMessageToCustomer(
    courseId,
    courseRecordDto,
    employeeId,
    phoneNumber
  )
  // dispatch(slice.actions.setCustomerServiceProgressList(updateRecord.data))
  if(!ispackage){
  dispatch(slice.actions.updateCustomerServiceArray(updateRecord.data))
  }
}

export const UpdateSignatureMessage = (  
  serviceArray,
  selectedIndex,
  ispackage,
) => async (dispatch) => {
  
  dispatch(slice.actions.setSelectedIndex(selectedIndex))
  // const updateRecord = await customerApi.UpdateTimesToCustomer(
  //   courseId,
  //   courseProductId,
  //   times
  // )
  // dispatch(slice.actions.setCustomerServiceProgressList(updateRecord.data))
  if(!ispackage){
  dispatch(slice.actions.updateTimesCustomerServiceArray(serviceArray))
  }
}

export default slice
